import React, { useRef, useEffect } from "react";
import { Card, Button, Tabs } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModelDispatchers, useModel } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import CustomerForm from "./CustomerForm";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const { closeNav } = useModelDispatchers("nav");
    const [{ tabsKey }, { setTabsKey }] = useModel("customer")
    const formRef = useRef();
    const onSave = () => {
        formRef.current.update();
    }
    const onReset = () => {
        formRef.current.reset();
    }
    const onClose = () => {
        closeNav();
    }

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">客户明细</span>
                </h3>
                {tabsKey == 1 || tabsKey == null ?
                    <div style={{ width: "500px", textAlign: "right" }}>
                        <YhAuth resCode={ResourceAuthEnum.DATA_C_ED_SAVE}>
                            <Button type="primary" onClick={onSave}>保存</Button>
                        </YhAuth>
                        <Button className="margin-left-8" onClick={onReset}>重置</Button>
                        <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                    </div> : ""}
            </div>
        )
    }
    useEffect(() => {
        setTabsKey(1)
    }, [])
    const _onChange = (key) => {
        setTabsKey(key)
    }
    const TabPane = [
        { key: "resizeLimit", name: "调额记录" },
        { key: "recharge", name: "充值记录" },
        { key: "transferAccounts", name: "转账记录" },
    ]
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <Tabs tabPosition="top"
                onChange={_onChange}
            >
                <Tabs.TabPane tab="基本信息" key="1">
                    <CustomerForm formRef={formRef} actionType={CM_ACTION_TYPE.EDIT} />
                </Tabs.TabPane>
                {/* <Tabs.TabPane tab="账户信息" key="2">
                    <AccountList/>
                </Tabs.TabPane>
                {
                    TabPane.map(item=>{
                        return (
                            <Tabs.TabPane tab={item.name} key={item.key}>                    
                                <CustomerRechargeList key={item.key} name={item.key} />                             
                            </Tabs.TabPane>
                        )
                    })
                } */}
            </Tabs>

        </Card>
    )
};